import { render, staticRenderFns } from "./dates-dialog.vue?vue&type=template&id=06118534&scoped=true&"
import script from "./dates-dialog.vue?vue&type=script&lang=js&"
export * from "./dates-dialog.vue?vue&type=script&lang=js&"
import style0 from "./dates-dialog.vue?vue&type=style&index=0&id=06118534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06118534",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
